import danone from "@/assets/clients/danone.webp.asset.json";
import sunweb from "@/assets/clients/subweb-group.webp.asset.json";
import nvwa from "@/assets/clients/nvwa.webp.asset.json";
import denHaag from "@/assets/clients/gemeente-den-haag.webp.asset.json";
import rotterdam from "@/assets/clients/gemeente-rotterdam.webp.asset.json";
import europol from "@/assets/clients/europol.webp.asset.json";
import shell from "@/assets/clients/shell.webp.asset.json";
import defensie from "@/assets/clients/ministerie-van-defensie.webp.asset.json";
import tuDelft from "@/assets/clients/tu-delft.webp.asset.json";

const logos = [
  { src: danone.url, alt: "Danone" },
  { src: sunweb.url, alt: "Sunweb Group" },
  { src: nvwa.url, alt: "NVWA" },
  { src: denHaag.url, alt: "Gemeente Den Haag" },
  { src: rotterdam.url, alt: "Gemeente Rotterdam" },
  { src: europol.url, alt: "Europol" },
  { src: shell.url, alt: "Shell" },
  { src: defensie.url, alt: "Ministerie van Defensie" },
  { src: tuDelft.url, alt: "TU Delft" },
];

// Pure CSS marquee: the list is rendered twice and translated by -50%,
// so the loop is seamless. Markup is static → identical on server and client.
const LogoList = ({ hidden }: { hidden?: boolean }) => (
  <ul className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {logos.map((l) => (
      <li key={l.alt} className="shrink-0 px-4 md:px-8">
        <img
          src={l.src}
          alt={hidden ? "" : l.alt}
          width={320}
          height={160}
          loading="lazy"
          decoding="async"
          className="h-16 md:h-20 w-auto object-contain"
        />
      </li>
    ))}
  </ul>
);

const ClientLogos = () => (
  <section className="py-16 md:py-20 bg-background" aria-labelledby="client-logos-heading">
    <div className="container">
      <h2
        id="client-logos-heading"
        className="text-2xl md:text-3xl font-bold text-center mb-10 text-[#0a2933]"
      >
        Deze klanten gingen u voor
      </h2>
    </div>
    <div className="logo-marquee relative overflow-hidden">
      <div className="logo-marquee-track flex w-max">
        <LogoList />
        <LogoList hidden />
      </div>
    </div>
  </section>
);

export default ClientLogos;
